<template>
  <div class="flex h-full w-full">
    <!-- Contenu principal -->
    <div class="p-5 w-full min-h-full">
      <!--Contenu partie droite -->
      <router-view :key="$route.fullPath" />
    </div>
  </div>

</template>

<script>

export default {
  name: 'Snippets',
  data: () => ({
    retrieved: false,
    windowSize: 0,
    modes: [
      { name: 'HTML', mime: 'text/html' },
      { name: 'CSS', mime: 'text/css' },
      { name: 'JavaScript', mime: 'text/javascript' },
      { name: 'Vue.js', mime: 'text/x-vue' },
    ],
    cursor: {
      line: 1,
      column: 1,
    },
  }),
  methods: {
    resizeHandler() {
      this.windowSize = window.innerWidth
    },
    changeMode(mode) {
      this.$store.dispatch('files/update', {
        fileId: this.file.id,
        folderId: this.file.folderId,
        data: {
          mode,
        },
      })
    },
    getMimeName(mime) {
      return this.modes.find((mode) => mode.mime === mime).name
    },
  },
  computed: {
    isFileActive() {
      return this.$store.state.activeFile !== ''
    },
    file() {
      return this.$store.getters['files/activeFile']
    },
  },
  mounted() {
    this.resizeHandler()
    window.addEventListener('resize', this.resizeHandler)
    // const { CodeMirror } = document.querySelector('.CodeMirror');
  },
}
</script>
